import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { Box, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ForumOutlined from "@mui/icons-material/ForumOutlined";

import ChatList from "../../components/InternalChat/ChatList";
import ConversationPanel from "../../components/InternalChat/ConversationPanel";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

// Visão dedicada do chat interno. A mesma dupla de componentes é usada na aba
// "Chat interno" dentro de Atendimentos — aqui só com mais espaço na tela.
const Shell = styled(Paper)(({ theme }) => ({
  display: "flex",
  flex: 1,
  margin: theme.spacing(1),
  overflow: "hidden",
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1]
}));

const ListPane = styled(Box, {
  shouldForwardProp: prop => prop !== "hideOnMobile"
})(({ theme, hideOnMobile }) => ({
  width: 320,
  minWidth: 320,
  display: "flex",
  flexDirection: "column",
  borderRight: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    minWidth: 0,
    borderRight: "none",
    display: hideOnMobile ? "none" : "flex"
  }
}));

const ConversationPane = styled(Box, {
  shouldForwardProp: prop => prop !== "hideOnMobile"
})(({ theme, hideOnMobile }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
  [theme.breakpoints.down("md")]: {
    display: hideOnMobile ? "none" : "flex"
  }
}));

const EmptyState = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  color: theme.palette.text.secondary,
  padding: theme.spacing(3),
  textAlign: "center"
}));

const InternalChat = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedChatId, setSelectedChatId] = useState(null);

  // Permite chegar direto numa conversa (?chatId=), que é como o botão
  // "pedir ajuda da equipe" da tela do ticket traz o atendente para cá.
  useEffect(() => {
    const target = searchParams.get("chatId");
    if (target) {
      setSelectedChatId(target);
      searchParams.delete("chatId");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <MainContainer>
      <MainHeader>
        <Title>Chat interno</Title>
      </MainHeader>

      <Shell>
        <ListPane hideOnMobile={!!selectedChatId}>
          <ChatList
            selectedChatId={selectedChatId}
            onSelect={setSelectedChatId}
          />
        </ListPane>

        <ConversationPane hideOnMobile={!selectedChatId}>
          {selectedChatId ? (
            <ConversationPanel
              chatId={selectedChatId}
              onBack={() => setSelectedChatId(null)}
            />
          ) : (
            <EmptyState>
              <ForumOutlined sx={{ fontSize: 48, opacity: 0.4 }} />
              <Typography variant="subtitle1">
                Selecione uma conversa
              </Typography>
              <Typography variant="body2">
                Converse com a equipe sem sair da plataforma. Cite um
                atendimento escrevendo <strong>#1234</strong> que vira link
                direto para o ticket, use <strong>@</strong> para chamar alguém
                num grupo, grave áudio e anexe arquivos até 25 MB.
              </Typography>
            </EmptyState>
          )}
        </ConversationPane>
      </Shell>
    </MainContainer>
  );
};

export default InternalChat;
